import service from '@/utils/request';
export var accountLoginLog = function accountLoginLog(data) {
  return service({
    url: "/xcpGameLog/accountLoginLog",
    method: 'post',
    data: data
  });
};